import React, { useState, useEffect } from "react";
import { Col, Row, Space, Tag, Typography } from "antd";
import { api } from "../../../../config/api";
import { getAuthToken } from "../../../../helpers/account";
import { Link } from "react-router-dom";
import AvatarDisplay from "../AvatarDisplay";
import { WalletFilled } from "@ant-design/icons";

const { Text } = Typography;

const AccountShortInfo = () => {
    const [company, setCompany] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAccountData = async () => {
            try {
                const response = await fetch(
                    `${api.host}/accounts/${sessionStorage.getItem("uuid")}/public`,
                    {
                        method: "GET",
                        headers: new Headers({
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${getAuthToken()}`,
                        }),
                    }
                );

                if (!response.ok) {
                    throw new Error("Failed to fetch account data");
                }

                const data = await response.json();
                setCompany(data);
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchAccountData();
    }, []);

    return (
        <div style={{ 
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", 
            padding: "16px 20px",
            borderBottom: "1px solid #e9ecef"
        }}>
            <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                    <AvatarDisplay src={company?.photo} account={company} size={48} />
                    <div style={{ flex: 1 }}>
                        <div style={{ marginBottom: "4px" }}>
                            <Link 
                                to={`/profile/${sessionStorage.getItem("uuid")}`}
                                style={{ 
                                    color: "white", 
                                    fontSize: "16px", 
                                    fontWeight: "500",
                                    textDecoration: "none"
                                }}
                            >
                                {company?.fullname || "Uzupełnij imię i nazwisko"}
                            </Link>
                        </div>
                        <Tag 
                            style={{ 
                                background: "rgba(255,255,255,0.2)", 
                                border: "1px solid rgba(255,255,255,0.3)",
                                color: "white",
                                borderRadius: "12px"
                            }}
                        >
                            <WalletFilled /> 100 TC
                        </Tag>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountShortInfo;